import React from 'react';
import {connect} from 'react-redux';
import {LanguageContext} from "../App";
import {predefinedRoutes} from '../predefinedRoutes';
import {getPuzzle} from "../api";
import {getDataFromHash} from "../state/puzzlesOnBoard";
import {hideRightMenu} from "../state/expandRightMenu";


class RightMenuDetailsRoutes extends React.Component {

    handleClick(hash) {
        this.props.setResetSimulator(true);
        getPuzzle(hash).then(data => {
            let url = window.location.href.split('/');
            if (url[url.length - 1].match(/[a-z0-9]{8}$/)) {
                window.history.pushState(null, null, window.location.href.replace(new RegExp(/[a-z0-9]{8}$/), data.hash));
            } else {
                url.push(hash);
                window.history.pushState(null, null, url.join('/'));
            }
            this.props.getDataFromHash(data.data, data.hash)
            this.props.hideRightMenu();
        });
    };

    render() {
        let routes = <LanguageContext.Consumer>
            {({language}) =>
                <ul className="predefinedList" style={{'padding': '0'}}>
                    {predefinedRoutes.map(route =>
                        <li key={route.hash}>
                            <div className="routeHeadline d-flex justify-content-between">
                                <div style={{width: 235, padding: 0}}>
                                    {language[route.name]}
                                </div>
                                <div className="d-flex flex-wrap p-0 justify-content-end">
                                    {route.hash_task &&
                                        <a className="loadRoute" onClick={() => this.handleClick(route.hash_task)}>
                                            <span style={{width: '100%'}} className="text-center">{language['zaladuj_zadanie']}</span>
                                        </a>
                                    }
                                    <a className="loadRouteButton" onClick={() => this.handleClick(route.hash)}>
                                        <span style={{width: '100%'}} className="text-center">{language['zaladuj_rozwiazanie']}</span>
                                    </a>
                                </div>
                            </div>
                            <div>
                                <picture>
                                    <source srcSet={route.img.slice(0, -3) + 'webp'} type="image/webp"/>
                                    <img className="" onClick={() => this.handleClick(route.hash)} src={route.img} alt=""/>
                                </picture>
                                <p className="">{language[route.description]}</p>
                            </div>
                            {route.link_scenarios ?
                                <p className={"aboutScenarios"}>{language['scenariusz']}{language[route.title]}{language['scenariusz_a']}
                                    <a href={'https://akademia.uczymydzieciprogramowac.pl/pl/scenariusze?utm_medium=route&utm_source=puzzle#search=' + language[route.link_scenarios]}>{language['pobierz_w_akademii']} </a>
                                    {language['scenariusz_b']}
                                    <a href={'https://edu-sense.com/pl/produkty/' + language[route.link_buy_education]}>{language[route.early_school_education]} </a>
                                    {language['scenariusz_c']}
                                </p>
                                :
                                ''
                            }
                            {route.link_cards ?
                                <p className={"aboutScenarios"}>{language['scenariusz']}{language[route.title]}{language['scenariusz_a']}
                                    <a href={'https://akademia.uczymydzieciprogramowac.pl/pl/scenariusze?utm_medium=route&utm_source=puzzle#search=' + language[route.link_cards]}>{language['pobierz_w_akademii']} </a>
                                </p>
                                :
                                ''
                            }
                            {route.link_buy_scenarios ?
                                <p className={"aboutScenarios"}>{language['scenariusz']}{language[route.title]}{language['scenariusz_d']}
                                    <a href={'https://edu-sense.com/pl/produkty/' + language[route.link_buy_education]}>{language[route.early_school_education]} </a>
                                    {language['scenariusz_e']}
                                </p>
                                :
                                ''
                            }
                            <p className={"puzzleInfo"}>{language['zestawy_do_zbudowania_trasy']}
                                <a href={'https://edu-sense.com/pl/produkty/drewniane-puzzle-do-ozobota-zestaw' + language[route.link_puzzles]}>{language[route.buy_puzzles]} </a>
                            </p>
                        </li>)}
                </ul>
            }
        </LanguageContext.Consumer>;

        return (
            <div className='right-menu-details-container' id={this.props.id} style={this.props.style}>
                <div className='right-menu-details-container-content'>
                    {routes}
                </div>
            </div>
        )
    }
}

export default connect(
    state => ({}),
    {getDataFromHash, hideRightMenu}
)(RightMenuDetailsRoutes);



// WEBPACK FOOTER //
// ./src/RightMenu/RightMenuDetailsRoutes.js